import text from '../text';

export const OCCUPATION = {
  ARCHITECT_DESIGNER: text('architectDesigner'),
  STRUCTURAL_ENGINEER: text('structuralEngineer'),
  MEPF_ENGINEER: text('mepfEngineer'),
  PROPERTY_DEVELOPER: text('propertyDeveloper'),
  PROJECT_MANAGER: text('projectManager'),
  BUILDER_TRADE: text('builderTrade'),
  LANDSCAPE_URBAN_DESIGNER: text('landscapeUrbanDesigner'),
  TOWN_PLANNER: text('townPlanner'),
  FACILITY_MANAGER: text('facilityManager'),
  SURVEYOR: text('surveyor'),
  OTHER: `${text('other')}?`,
};
